module.exports = __webpack_public_path__ + "static/media/easy-book-w.27b7aae6.svg";